import { compose, hoistStatics, withHandlers, withProps } from 'recompose';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';

import Message from './Message';
import UserService from '../../../../../../services/user.service';
import dh from '../../../../../../helpers/date.helper';
import { uploadActions } from '../../../../../../reducers/upload';

const setEditMessage = props => (e, item) => {
  e.preventDefault();
  const { setMessageToEdit, updateMulFiles, upload_name, removeMulTempFiles } = props;
  removeMulTempFiles(upload_name)
  const files = item.files.map(f => ({ ...f, original: f.filename }));
  updateMulFiles({ files, id: upload_name });
  setMessageToEdit(item);
};

const mapStateToProps = state => ({
  user: state.user.user,
  messenger: state.messenger,
  token: state.auth.token,
});

const mapDispatchToProps = {
  updateMulFiles: uploadActions.updateMulFiles,
  removeMulTempFiles: uploadActions.removeMulTempFiles,
};

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  translate('portal'),
  withProps(props => ({
    ...props,
    src: UserService.getAvatar({ ...props.item, token: props.token }),
    time: dh.getLastMessageTime(props.item.created_at),
  })),
  withHandlers({
    setEditMessage,
  }),
);

export default hoistStatics(enhance)(Message);



// WEBPACK FOOTER //
// ./src/views/modules/messages/chat/chatBox/message/index.js